module.exports = __webpack_public_path__ + "static/media/icomoon.ae4abf7a.svg";